import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { apiRequest } from "../../utils/api";

const empty = { name: "", description: "", displayOrder: 0, isActive: true };

const UniformTypeSettings = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [edit, setEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);

  const load = () => {
    setLoading(true);
    return apiRequest("/api/admin/settings/uniform-types", {}, navigate)
      .then((r) => setRows(r.data || []))
      .catch((e) => alert(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const ch = (e) =>
    setForm({
      ...form,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });

  const save = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    try {
      const method = edit ? "PUT" : "POST";
      await apiRequest(
        `/api/admin/settings/uniform-types${edit ? `/${edit}` : ""}`,
        { method, body: form },
        navigate,
      );
      setForm(empty);
      setEdit(null);
      await load();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  const del = async (id) => {
    if (deleting || !window.confirm("Delete this uniform type?")) return;
    setDeleting(id);
    try {
      await apiRequest(
        `/api/admin/settings/uniform-types/${id}`,
        { method: "DELETE" },
        navigate,
      );
      await load();
    } finally {
      setDeleting(null);
    }
  };

  return (
    <DashboardLayout title="Uniform Type Settings">
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4>Uniform Type Settings</h4>
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate("/settings")}
            type="button"
          >
            Back
          </button>
        </div>
        <div className="card p-3 mb-3">
          <form onSubmit={save} className="row g-3">
            <div className="col-md-3">
              <label>Uniform Type Name</label>
              <input
                required
                className="form-control"
                name="name"
                value={form.name}
                onChange={ch}
              />
            </div>
            <div className="col-md-4">
              <label>Description</label>
              <input
                className="form-control"
                name="description"
                value={form.description || ""}
                onChange={ch}
              />
            </div>
            <div className="col-md-2">
              <label>Display Order</label>
              <input
                type="number"
                className="form-control"
                name="displayOrder"
                value={form.displayOrder}
                onChange={ch}
              />
            </div>
            <div className="col-md-1 d-flex align-items-end">
              <label>
                <input
                  type="checkbox"
                  name="isActive"
                  checked={!!form.isActive}
                  onChange={ch}
                />{" "}
                Active
              </label>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary" disabled={saving}>
                {saving&&<span className="spinner-border spinner-border-sm me-2"/>}{saving ? "Saving..." : edit ? "Update" : "Create"}
              </button>
            </div>
          </form>
        </div>
        <div className="card table-responsive">
          <table className="table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Description</th>
                <th>Display Order</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="text-center py-4"><span className="spinner-border spinner-border-sm me-2"/>Loading...</td></tr>
              ) : rows.length ? rows.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.name}</td>
                  <td>{r.description}</td>
                  <td>{r.displayOrder}</td>
                  <td>{r.isActive ? "Yes" : "No"}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      disabled={saving || deleting === r.id}
                      onClick={() => {
                        setEdit(r.id);
                        setForm({
                          name: r.name,
                          description: r.description || "",
                          displayOrder: r.displayOrder || 0,
                          isActive: !!r.isActive,
                        });
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      disabled={saving || !!deleting}
                      onClick={() => del(r.id)}
                    >
                      {deleting===r.id?"Deleting...":"Delete"}
                    </button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="6" className="text-center py-4">No uniform types found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UniformTypeSettings;
